/**
 * Accordion component — binds click handlers on `.lux-accordion` elements
 * to toggle content panels open/closed.
 */
const luxAccordions = {
    /**
     * Bind click handlers on all `.lux-accordion` elements.
     *
     * @returns {void}
     */
    init() {
        const luxAccordions = document.querySelectorAll(".lux-accordion");

        luxAccordions.forEach(function (accordion) {
            const htmlAccordion = /** @type {HTMLElement} */ (accordion);
            if (htmlAccordion.dataset.initialized === "true") return;

            const luxToggles = accordion.querySelectorAll(
                "*[data-toggle='lux-accordion']",
            );
            const luxContents = accordion.querySelectorAll(".content");

            luxToggles.forEach(function (toggle) {
                const dataTarget = toggle.getAttribute("data-target");
                if (!dataTarget) return;

                const target = document.getElementById(dataTarget);
                if (!target) return;

                toggle.addEventListener("click", function () {
                    misc.slideToggle(target);

                    luxContents.forEach(function (content) {
                        if (content !== target) {
                            misc.slideUp(content);
                        }
                    });

                    luxToggles.forEach(function (el) {
                        if (el !== toggle) {
                            el.setAttribute("aria-expanded", "false");
                        }
                    });

                    const isExpanded =
                        toggle.getAttribute("aria-expanded") === "true";
                    toggle.setAttribute(
                        "aria-expanded",
                        isExpanded ? "false" : "true",
                    );
                });
            });

            accordion.classList.add("accordion-ready");
            htmlAccordion.dataset.initialized = "true";
        });
    },
};

window.luxAccordions = luxAccordions;

if (document.querySelector(".lux-accordion")) {
    luxAccordions.init();
}

export {};
